import { Injectable } from "@angular/core";
import { databases, ID, storage } from "../config/appwrite";
import { environment } from "../../../environments/environment";
import { EspecialistaOtrosService } from "./especialista-otros.service";
import { EspecialistaTarifaService } from "./especialista-tarifa.service";
import { EspecialistaAgendaService } from "./especialista-agenda.service";
import { Especialista } from "../models";
import { BucketsService } from "./buckets.service";
import { Query } from "appwrite";

@Injectable({
  providedIn: "root",
})
export class EspecialistaService {
  private collectionId = "especialistas";
  private DATABASE_NAME = environment.databaseName;
  private BUCKET_FOTOS_ESPECIALISTAS = environment.bucketFotosEspecialistas;
  private BUCKET_FIRMA_ESPECIALISTAS = environment.bucketFirmaEspecialistas;

  constructor(
    private __especialistaOtrosService: EspecialistaOtrosService,
    private __especialistaTarifaService: EspecialistaTarifaService,
    private __especialistaAgendaService: EspecialistaAgendaService,
    private __bucketService: BucketsService
  ) {}

  /**
   *getEspecialistas
   * @returns
   */
  getEspecialistas(): Promise<Especialista[]> {
    return databases
      .listDocuments<Especialista>(this.DATABASE_NAME, this.collectionId)
      .then((response) => response.documents);
  }

  /**
   *getDocumentActive
   * @returns
   */
  getDocumentActive(): Promise<Especialista[]> {
    return databases
      .listDocuments<Especialista>(this.DATABASE_NAME, this.collectionId, [
        Query.equal("activo", true),
      ])
      .then((response) => response.documents);
  }

  /**
   * @createDocument()
   * @param data
   * @returns
   */
  createDocument(data: Especialista) {
    return databases.createDocument(
      this.DATABASE_NAME,
      this.collectionId,
      ID.unique(),
      data
    );
  }

  /**
   * @updateDocument()
   * @param idDocument
   * @param data
   * @returns
   */
  updateDocument(idDocument: string, data: Especialista) {
    data.$databaseId = "";
    data.$collectionId = "";
    return databases.updateDocument(
      this.DATABASE_NAME,
      this.collectionId,
      idDocument,
      data
    );
  }

  /**
   * @uploadFile
   * @param file
   * @returns
   */
  uploadPhoto(file: File): Promise<any> {
    return storage.createFile(
      this.BUCKET_FOTOS_ESPECIALISTAS,
      ID.unique(),
      file
    );
  }

  /**
   *
   * @param idImagen
   * @returns
   */
  getPhoto(idImagen: string) {
    return storage.getFile(this.BUCKET_FOTOS_ESPECIALISTAS, idImagen);
  }

  /**
   * @getDocument()
   * @param idDocument
   * @returns
   */
  getDocument(idDocument: string) {
    return databases.getDocument(
      this.DATABASE_NAME,
      this.collectionId,
      idDocument
    );
  }
  /**
   * @uploadFirma
   * @param file
   * @returns
   */
  uploadFirma(file: File): Promise<any> {
    return storage.createFile(
      this.BUCKET_FIRMA_ESPECIALISTAS,
      ID.unique(),
      file
    );
  }

  /**
   *
   * @param idImagen
   * @returns
   */
  getFirma(idImagen: string) {
    return storage.getFile(this.BUCKET_FIRMA_ESPECIALISTAS, idImagen);
  }

  /**
   * 1. Aqui se consulta todos los especialistas del sistema con estado activo y ordenado por valoración
   * 2. Mientras lee cada especialista consulta
   *   2.1. Trae sus especialidades
   *   2.2. Trae sus tarifas
   *   2.3. Trae sus agendas
   *
   * @returns
   *  UN ARREGLO CON ESTA INFORMACIÓN.
   *
   */

  // async getEspecialistasComplete(pacienteAntiguo): Promise<any[]> {
  //   // Consulta para obtener los especialistas
  //   let queryConditions = [
  //     Query.select([
  //       "nombre",
  //       "$id",
  //       "descripcion",
  //       "foto",
  //       "perfil.especialidad",
  //       "valoracion",
  //     ]),
  //     Query.orderDesc("valoracion"),
  //     Query.equal("activo", true),
  //     Query.limit(200),
  //   ];
  //   // Añadimos la condición de pacienteAntiguo solo si es true
  //   if (pacienteAntiguo === true) {
  //     // PACIENTE ANTIGUO -> TRAE TODOS LOS ESPECIALISTAS DEL SISTEMA
  //     // queryConditions.push(Query.notEqual('soloPacientesAntiguos', true));
  //   } else {
  //     //PACIENTE NUEVO -> SOLO ESPECIALISTAS QUE ACEPTEN TODOS LOS PACIENTES NUEVOS
  //     queryConditions.push(Query.notEqual("soloPacientesAntiguos", true));
  //   }

  //   // Obtener especialistas
  //   const especialistasResponse = await databases.listDocuments<any>(
  //     this.DATABASE_NAME,
  //     this.collectionId,
  //     queryConditions
  //   );

  //   const especialistas = especialistasResponse.documents;

  //   // Para cada especialista, obtener su agenda de los próximos 3 meses
  //   const especialistasConAgenda = await Promise.all(
  //     especialistas.map(async (especialista) => {
  //       // Consulta para obtener la agenda del especialista
  //       const agendaQueryConditions = [
  //         Query.equal("idEspecialista", especialista.$id),
  //         Query.limit(100), // Limitar el número de registros de agenda
  //       ];

  //       const agendaResponse = await databases.listDocuments(
  //         this.DATABASE_NAME,
  //         "especialistas_agenda",
  //         agendaQueryConditions
  //       );

  //       // Añadir la agenda al especialista
  //       return {
  //         ...especialista,
  //         agenda: agendaResponse.documents,
  //       };
  //     })
  //   );

  //   return especialistasConAgenda;
  // }

  getEspecialistasComplete(pacienteAntiguo, offset = 0, limit = 6): Promise<any[]> {
    // Esta función trae una lista de especialistas desde Appwrite.
    // - pacienteAntiguo: si el usuario es paciente recurrente.
    // - offset: cuántos resultados omitir (para paginación).
    // - limit: cuántos especialistas traer (máximo).

    //Difinición de condiciones para consulta
    let queryConditions = [
      // Seleccionar solo ciertos campos del especialista
      Query.select([
        "nombre",
        "$id",
        "descripcion",
        "foto",
        "perfil.especialidad",
        "valoracion",
      ]),
      Query.orderDesc("valoracion"),
      Query.equal("activo", true),
      Query.offset(offset),
      Query.limit(limit),
    ];
    
    // Si el paciente NO es antiguo, excluir a los especialistas solo para pacientes antiguos
    if (!pacienteAntiguo) {
      queryConditions.push(Query.notEqual("soloPacientesAntiguos", true));
    }
  
    //console.log("🧪 queryConditions:", queryConditions);
    
    // Consulta a la base de datos de appwrite
    return databases
      .listDocuments<any>(this.DATABASE_NAME, this.collectionId, queryConditions)
      .then((especialistas) => {
        console.log("✅ Resultado bruto Appwrite:", especialistas);
  
        if (!especialistas.documents || especialistas.documents.length === 0) {
          //console.warn("⚠️ No llegaron especialistas. Verifica filtros o datos.");
          return [];
        }

        // Por cada especialista encontrado, obtener sus datos adicionales (foto, especialidades, servicios)
        const promesasRelacionadas = especialistas.documents.map((especialista, index) => {
          //console.log(`👤 Especialista[${index}]:`, especialista);
  
          especialista.foto = especialista.foto
            ? this.__bucketService.getBucket(this.BUCKET_FOTOS_ESPECIALISTAS, especialista.foto)
            : environment.imageUserDefault;
          
          // Traer especialidades y servicios del especialista
          return Promise.all([
            // Trae las especialidades del especialista
            this.__especialistaOtrosService
              .getDocuments(especialista.$id)
              .then((esp) => {
                especialista.especialidades = esp;
              }),

            // Trae los servicios y tarifas del especialista
            this.__especialistaTarifaService
              .getDocuments(especialista.$id)
              .then((serv) => {
                especialista.servicios = serv;
              }),
              
            // La parte de agenda está comentada
            /*
            this.__especialistaAgendaService
              .getDocumentsByEspecialistagreaterThanCurrentDate(especialista.$id)
              .then((agenda) => {
                especialista.agenda = agenda;
              }),*/
          ]).then(() => especialista);
        });
  
        return Promise.all(promesasRelacionadas);
      })
      .catch((error) => {
        console.error("❌ Error en listDocuments:", error);
        throw error;
      });
  }

  // Listado de todos los especialistas en modo básico
  getEspecialistasBasico(especialistaPrioritarioId?: string): Promise<any[]> {
    // Construimos query base
    const queries = [
      Query.equal('activo', true),
      Query.orderDesc('valoracion'),
      Query.select([
        '$id',
        'descripcion',
        'nombre',
        'foto',
        'perfil.especialidad',
        'valoracion',
      ]),
      Query.limit(50),
    ];

    return databases
      .listDocuments<any>(this.DATABASE_NAME, this.collectionId, queries)
      .then((especialistas) => {
        // Priorizar especialista si viene id (solo en la primera página, para evitar problemas)
        if (especialistaPrioritarioId) {
          const especialistaPrioritario = especialistas.documents.find(
            (esp) => esp.$id === especialistaPrioritarioId
          );

          if (especialistaPrioritario) {
            const otrosEspecialistas = especialistas.documents.filter(
              (esp) => esp.$id !== especialistaPrioritarioId
            );
            especialistas.documents = [
              especialistaPrioritario,
              ...otrosEspecialistas,
            ];
          }
        }

        // Mapear y traer datos relacionados
        const promesasRelacionadas = especialistas.documents.map(
          (especialista) => {
            if (especialista.foto === null) {
              especialista.foto = environment.imageUserDefault;
            } else {
              especialista.foto = this.__bucketService.getBucket(
                this.BUCKET_FOTOS_ESPECIALISTAS,
                especialista.foto
              );
            }

            return especialista;
          }
        );

        return Promise.all(promesasRelacionadas);
      });
  }

  // Obtenemos un especialista, FOTO, FIRMA, SERVICIOS,TARIFAS,AGENDA, DOCUMENTOS
  getEspecialistaOneBasico(idDocument: string): Promise<any[]> {
    return (
      databases
        .listDocuments<any>(this.DATABASE_NAME, this.collectionId, [
          Query.equal('$id', idDocument),
          Query.equal('activo', true),
          Query.orderDesc('valoracion'),
          Query.select([
            '$id',
            'descripcion',
            'nombre',
            'foto',
            'perfil.especialidad',
            'valoracion',
          ]),
          Query.limit(1),
        ])

        // return databases
        //   .getDocument(this.DATABASE_NAME, this.collectionId, idDocument)
        .then((especialistas) => {
          // console.log('ESPECIALISTA UNO:', especialistas);

          const promesasRelacionadas = especialistas.documents.map(
            (especialista) => {
              // console.log('ESPECIALISTA complete:', especialista);
              if (especialista.foto === null) {
                especialista.foto = environment.imageUserDefault;
              } else {
                especialista.foto = this.__bucketService.getBucket(
                  this.BUCKET_FOTOS_ESPECIALISTAS,
                  especialista.foto
                );
              }
              return especialista;
            }
          );
          return Promise.all(promesasRelacionadas);
        })
    );
  }

  // Aqui no devuelve un array con el listado de especialistas sino un solo especialista
  getEspecialistaOneCompleteNew(idDocument: string): Promise<any> {
    return databases
      .getDocument(this.DATABASE_NAME, this.collectionId, idDocument, [
        Query.select(['$id', 'nombre', 'linkCita']),
      ])
      .then((especialista) => {
        const promesasDatosRelacionados = [
          this.__especialistaOtrosService
            .getDocuments(especialista.$id)
            .then(
              (especialidades) => (especialista.especialidades = especialidades)
            ),
          this.__especialistaTarifaService
            .getDocuments(especialista.$id)
            .then((servicios) => (especialista.servicios = servicios)),
        ];

        return Promise.all(promesasDatosRelacionados).then(() => especialista);
      });
  }

  // LLAMADO DESDE ENCUENTRA A TU ESPECIALISTA
  getEspecialistasEncuentra(pacienteAntiguo, formData): Promise<any[]> {
    console.log(formData);
    console.log("getEspecialistasEncuentra", formData["step3"]);

    /**
     * {
    "step0": "Presencial",
    "step1": "6-12",
    "step2": "pareja",
    "step3": "M",
    "step4": [
        "duelo"
    ]
}
     */

    // Creamos un array con las condiciones base
    let queryConditions = [
      Query.select([
        "nombre",
        "$id",
        "descripcion",
        "foto",
        "perfil.especialidad",
        "valoracion",
      ]),
      Query.orderDesc("valoracion"),
      Query.equal("activo", true),
      Query.limit(50),
    ];

    // Creamos un array para las condiciones del AND
    let andConditions = [];

    // Solo agregamos el filtro de género si NO es 'indiferente'
    if (formData["step3"] !== "indiferente") {
      andConditions.push(Query.equal("genero", formData["step3"]));
    }

    // Modalidad Presencial o Virtual
    let modalidad = formData["step0"]
    // Normalizamos las modalidades que empiecen por Precencial_
    if (modalidad.startsWith("Presencial_")){
      modalidad ="Presencial";
    }
    andConditions.push(Query.equal("tModalidad", modalidad));

    // Filtrar por id de ciudad
    if(formData.ciudadId){
      andConditions.push(Query.equal("idCiudadAtencion", formData.ciudadId));
    }else{
      console.log(`Los ids son ${formData.ciudadId}`)
    }

    // Si tenemos condiciones para el AND, las agregamos
    if (andConditions.length > 1) {
      queryConditions.push(Query.and(andConditions));
    } else if (andConditions.length === 1) {
      // Si solo hay una condición, la agregamos directamente
      queryConditions.push(andConditions[0]);
    }

    // Añadimos la condición de pacienteAntiguo solo si es true
    if (pacienteAntiguo === true) {
      // PACIENTE ANTIGUO -> TRAE TODOS LOS ESPECIALISTAS DEL SISTEMA
      // queryConditions.push(Query.notEqual('soloPacientesAntiguos', true));
    } else {
      //PACIENTE NUEVO -> SOLO ESPECIALISTAS QUE ACEPTEN TODOS LOS PACIENTES NUEVOS
      // queryConditions.push(Query.notEqual("soloPacientesAntiguos", true));
    }

    console.log("Query Conditions:", JSON.stringify(queryConditions, null, 2));

    // Trae los especialistas
    return databases
      .listDocuments<any>(
        this.DATABASE_NAME,
        this.collectionId,
        queryConditions
      )
      .then((especialistas) => {
        const promesasRelacionadas = especialistas.documents.map(
          (especialista) => {
            // Reemplaza la variable del objeto foto de su id a la url
            // especialista.foto = this.__bucketService.getBucket(this.BUCKET_FOTOS_ESPECIALISTAS, especialista.foto);
            if (especialista.foto === null) {
              especialista.foto = environment.imageUserDefault;
            } else {
              especialista.foto = this.__bucketService.getBucket(
                this.BUCKET_FOTOS_ESPECIALISTAS,
                especialista.foto
              );
            }

            // Se define variable para guardar alli los objetos consultados.
            const promesasDatosRelacionados = [
              // Trae las especialidades
              this.__especialistaOtrosService
                .getDocuments(especialista.$id)
                .then(
                  (especialidades) =>
                    (especialista.especialidades = especialidades)
                ),
              // Trae las tarifas
              this.__especialistaTarifaService
                .getDocuments(especialista.$id)
                .then((servicios) => (especialista.servicios = servicios)),
              // Trae las agendas
              this.__especialistaAgendaService
                .getDocumentsByEspecialistagreaterThanCurrentDate(
                  especialista.$id
                )
                .then((agenda) => (especialista.agenda = agenda)),
            ];
            // Esperamos a que todas las solicitudes se completen
            return Promise.all(promesasDatosRelacionados).then(
              () => especialista
            );
          }
        );

        // Esperamos a que todas las solicitudes de tarifas se completen
        return Promise.all(promesasRelacionadas);
      });
  }
}
